export default "__VITE_ASSET__B_NEdG9X__"